import { render, staticRenderFns } from "./GiftObjects.vue?vue&type=template&id=0419e916"
import script from "./GiftObjects.vue?vue&type=script&lang=js"
export * from "./GiftObjects.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports